import { StringTMap } from '@@types/common';

const performanceData: StringTMap<number> = {};
export default performanceData;
